<div class="modal-content">
  <img class="logo-loading" [src]="LOADER_URL" alt="loading" />
</div>
